import { VerifyDocsFields as Fields, VerifyDocsForm as Form } from '../api';
export { VerifyDocsFields as Fields, verifyDocsFormId as formId } from '../api';

export const initialValues: Form = {
  [Fields.identities]: [{ [Fields.identityFile]: undefined }],
  [Fields.utilities]: [{ [Fields.utilityFile]: undefined }],
};
